import { render, staticRenderFns } from "./olmap.vue?vue&type=template&id=87b754fc&"
import script from "./olmap.vue?vue&type=script&lang=js&"
export * from "./olmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports